import OT from "@opentok/client";

const state = {
  videoToken: "",
  videoSession: null,
};

const getters = {
  videoToken: (state) => {
    return state.videoToken;
  },
  videoSession: (state) => {
    return state.videoSession;
  },
};

const mutations = {
  setVideoToken: (state, videoToken) => {
    state.videoToken = videoToken;
  },
  setVideoSession: (state, videoSession) => {
    state.videoSession = videoSession;
  },
};

const actions = {
  establishVideoConnection: async (context, data) => {
    context.commit("setVideoSession", OT.initSession(data.apiKey, data.id));
    context.commit("setVideoToken", data.token);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
